import { versions } from "./versions";

export const environment = {
  production: true,
  origin: "https://api.pilot.genalyte.com",
  envName: "pilot",
  versions,
  domain: "portal.pilot.genalyte.com"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts